import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from 'src/app/configs/api.config';
import { Subject } from 'rxjs';
// import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';

@Injectable()
export class FirmwareManagerService {

  CurrentDeviceType;
  CurrentFirmwareId;

  contentChange = new Subject;

  constructor(
    private http: HttpClient,
    // private sanitizer: DomSanitizer
  ) { }

  // 获取专属设备列表
  getProDeviceList() {
    return this.http.get<ResponseModel>(API.ROOT + '/device-types')
      .toPromise()
      .then((response: ResponseModel) => {
        // console.log(response);
        if (response.message == 1000) {
          return response.detail
        }
      })
  }

  // 获取固件列表
  getFirmwareList(page, deviceType = '') {
    this.CurrentDeviceType = deviceType;
    return this.http.get<ResponseModel>(API.OTA + '/list' + ((deviceType == '') ? '' : `/${deviceType}`), {
      params: {
        page: page.pageNumber + 1,
        perPage: page.size
      }
    })
  }

  getFirmwareDetails(firmwareId) {
    return this.http.get<ResponseModel>(API.OTA + '/details', {
      params: {
        "firmwareId": firmwareId
      }
    })
  }

  // 上传固件
  uploadFirmware(firmware) {
    const formData = new FormData();
    formData.append('version', firmware.version);
    formData.append('deviceType', firmware.deviceType);
    formData.append('description', firmware.description);
    formData.append('file', firmware.file);
    return this.http.post<ResponseModel>(API.OTA, formData)
  }

  // 删除固件
  delFirmware(firmwareId) {
    return this.http.delete<ResponseModel>(API.OTA, {
      params: {
        "firmwareId": firmwareId
      }
    })
  }

  // 下载固件
  downloadFirmware(firmwareId) {
    this.http.get(API.OTA + '/download', {
      params: {
        "firmwareId": firmwareId
      },
      responseType: 'blob'
    })
      .toPromise()
      .then(data => {
        console.log('download');
        const blob = new Blob([data], { type: 'application/octet-stream' });
        saveAs(blob, firmwareId + '.bin');
      })
  }

  // 更改固件描述
  changeDescription(firmwareId, description) {
    return this.http.put<ResponseModel>(API.OTA, {
      "firmwareId": firmwareId,
      "description": description
    })
  }

  // 获取固件对应设备的列表
  getFirmwareDeviceList() {
    return this.http.get<ResponseModel>(API.OTA + '/check/devices', {
      params: {
        "page": "1",
        "perPage": "20"
      }
    });
  }

  // 向指定设备推送固件更新（开发者测试用）  
  publishFirmware2Devices(devices, firmwareId) {
    return this.http.post<ResponseModel>(API.OTA + '/test', {
      firmwareId: firmwareId,
      devices: JSON.stringify(devices)
    });
  }

  getTestState(firmwareId) {
    return this.http.get<ResponseModel>(API.OTA + '/test/state', {
      params: {
        firmwareId: firmwareId,
      }
    });
  }

  // 向所有设备推送固件更新（正式发布）  
  publishFirmware(firmwareId) {
    return this.http.post<ResponseModel>(API.OTA + '/publish', {
      firmwareId: firmwareId,
    });
  }

  checkUpdateState(firmwareId) {
    return this.http.get<ResponseModel>(API.OTA + '/update-state', {
      params: {
        "firmwareId": firmwareId,
      }
    });
  }

  getDeviceId(keyword, deviceType = this.CurrentDeviceType, num = "10") {
    return this.http.get<ResponseModel>(API.ROOT + '/complement/deviceid', {
      params: {
        deviceType: deviceType,
        keyword: keyword.toUpperCase(),
        num: num
      }
    });
  }

}
